import { render, staticRenderFns } from "./wall-list.vue?vue&type=template&id=9c72f99c&scoped=true"
import script from "./wall-list.vue?vue&type=script&lang=js"
export * from "./wall-list.vue?vue&type=script&lang=js"
import style0 from "./wall-list.vue?vue&type=style&index=0&id=9c72f99c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c72f99c",
  null
  
)

export default component.exports